import { Info } from "@phosphor-icons/react";
import { useIntercom } from "react-use-intercom";

import Alert from "common/components/ui/Alert";
import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

import { WHITELABEL_DOMAIN } from "../../constants";
import SettingsItemContainer from "../SettingsItemContainer";

export default function Email() {
  const { showNewMessage } = useIntercom();

  return (
    <SettingsItemContainer className="flex-col gap-y-1">
      <div className="flex items-center gap-x-1">
        <span className="text-button-sm">Sender email address</span>
        <Tooltip>
          <TooltipTrigger>
            <Info weight="fill" size={16} />
          </TooltipTrigger>
          <TooltipContent>
            The email address used for sending notifications and communications
            to your clients
          </TooltipContent>
        </Tooltip>
      </div>
      <span className="text-black-500 text-xs-medium">
        agency@{WHITELABEL_DOMAIN}
      </span>
      <Alert className="mr-auto w-[440px] mt-3">
        <div className="flex flex-col">
          <div className="gap-x-1.5 flex items-center mb-1 text-xs-bold">
            Custom email address
            <Tag variant="primary" size="sm">
              Premium
            </Tag>
          </div>
          Send emails from your own domain (e.g., noreply@youragency.com) for a
          fully branded experience
          <Button
            size="sm"
            variant="secondary-purple"
            className="mt-2.5 ml-auto"
            onClick={() => {
              showNewMessage(
                "Hello, i would like to update my agency whitelabel email address",
              );
            }}
          >
            Contact support
          </Button>
        </div>
      </Alert>
    </SettingsItemContainer>
  );
}
